export const ALLOW_PREDEFINED_VALUES: ValidAllow[] = ['payment', 'otp-credentials'];

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/Permissions_Policy#embedded_frame_syntax
 */
export const VALID_ALLOW = new Set([
    'payment',
    'fullscreen',
    'microphone',
    'camera',
    'web-share',
    'otp-credentials',
] as const);

type ValidAllowIterator = ReturnType<(typeof VALID_ALLOW)['values']>;
export type ValidAllow = ValidAllowIterator extends Iterator<infer T> ? T : never;

export const assertsValidAllow = (allow: string): asserts allow is ValidAllow => {
    if (!VALID_ALLOW.has(allow as ValidAllow)) {
        throw new Error(`Invalid allow value: "${allow}"`);
    }
};
